var CollapsingFilterList = React.createClass({
  propTypes: {
    items: React.PropTypes.array,
    defaultItems: React.PropTypes.array,
    displayBeforeFold: React.PropTypes.number,
    isInitiallyExpanded: React.PropTypes.bool,
    listClassName: React.PropTypes.string,
  },
  getDefaultProps() {
    return {
      items: [],
      displayBeforeFold: 4,
      isInitiallyExpanded: false,
      listClassName: "filter__list"
    }
  },
  getInitialState() {
    return {
      expanded: this.props.isInitiallyExpanded
    }
  },
  componentWillReceiveProps(nextProps) {
    this.setState({expanded: this.props.isInitiallyExpanded});
  },
  moreClicked(e) {
    this.setState({expanded: true});
  },
  lessClicked() {
    this.setState({expanded: false});
    window.scrollTo(0, $(this.refs.list).offset().top);
  },
  getMoreList(items) {
    return (
      <div>
        <ul className={this.props.listClassName}>
          {items}
        </ul>
      </div>
    )
  },
  getLessLink(visible = true) {
    // Link will always be in DOM, and use style to control visibility
    // Addresses issue with ResponsiveFilterColumn closing when clicking these links because they are removed
    // from the DOM and no longer detected as children of the filter column.
    return (
      <a href="#"
        className="icon-link"
        style={{display: visible ? "" : "none"}}
        onClick={this.lessClicked}>
        <span>{"- "}</span><span className="icon-link__text">{Labels.getLabel("See Less")}</span>
      </a>
    )
  },
  getMoreLink(visible = true) {
    // Link will always be in DOM, and use style to control visibility
    // Addresses issue with ResponsiveFilterColumn closing when clicking these links because they are removed
    // from the DOM and no longer detected as children of the filter column.
    return (
      <a href="#"
        className="icon-link"
        style={{display: visible ? "" : "none"}}
        onClick={this.moreClicked}>
        <span>{"+ "}</span><span className="icon-link__text">{Labels.getLabel("See more")}</span>
      </a>
    )
  },

  render() {
    let items = this.props.items || [];
    let beforeFoldIndex = Math.min(this.props.displayBeforeFold, items.length);
    let beforeFoldItems = items.slice(0, beforeFoldIndex);
    let hasMoreItems = items.length > beforeFoldIndex;
    let afterFoldItems;
    let moreLink;
    let lessLink;
    let moreList;

    if (hasMoreItems) {
      if (this.state.expanded) {
        afterFoldItems = items.slice(beforeFoldIndex);
        moreList = this.getMoreList(afterFoldItems);

        moreLink = this.getMoreLink(false);
        lessLink = this.getLessLink();
      } else {
        moreLink = this.getMoreLink();
        lessLink = this.getLessLink(false);
      }
    }

    return (
      <div>
        <ul className={this.props.listClassName} ref="list">
          {this.props.defaultItems}
          {beforeFoldItems}
        </ul>

        {moreLink}

        {moreList}

        {lessLink}
      </div>
    )
  }
});